/**
 * Client-side mirror of the backend CPT-to-karma offer defaults.
 * Used for displaying karma offers inline without an API call.
 */
const CPT_KARMA_OFFERS: Record<string, number> = {
  '99212': 4,
  '99213': 8,
  '99214': 16,
  '99215': 30,
};

export function karmaOfferForCpt(cptCode: string | null | undefined): number {
  if (!cptCode) return 0;
  return CPT_KARMA_OFFERS[cptCode] ?? 0;
}
